import { API_ERROR_CODES } from './error-codes'

export type PaymentProviderId =
  | 'stripe'
  | 'paypal'
  | 'payssion'
  | 'airwallex'
  // eslint-disable-next-line @typescript-eslint/ban-types
  | (string & {})

export interface ApiError {
  message: string
  code?: string
  status?: number
}

export class ApiRequestError extends Error {
  readonly code: string | undefined
  readonly status: number | undefined

  constructor(message: string, code?: string, status?: number) {
    super(message)
    this.name = 'ApiRequestError'
    this.code = code
    this.status = status
  }

  isEmailError(): boolean {
    return this.code === API_ERROR_CODES.INVALID_EMAIL
  }
}

export interface ApiResponse<T> {
  data?: T
  error?: ApiError
}

export type PaymentMethodCheckoutField =
  | 'email'
  | 'given_name'
  | 'family_name'
  | 'cardholder_name'
  | 'billing_country'
  | 'billing_postal_code'
  | 'billing_region'
  | 'billing_line1'
  | 'billing_line2'
  | 'billing_city'
  | 'phone_number'
  | 'browser_context'
  | 'client_timezone'
  | 'payment_token'

export type PaymentMethodCheckoutRequirement =
  | 'required'
  | 'conditional'
  | 'recommended'
  | 'provider_auto'
  | 'internal'
  | 'not_collected'

export type PaymentMethodCheckoutCollection =
  | 'checkout_form'
  | 'provider_component'
  | 'wallet_sheet'
  | 'request_context'
  | 'platform_profile'
  | 'not_collected'

export interface PaymentMethodFieldCapability {
  requirement: PaymentMethodCheckoutRequirement
  collection: PaymentMethodCheckoutCollection
  reason?: string
  required_countries?: string[]
}

export type PaymentMethodCheckoutFields = Partial<
  Record<PaymentMethodCheckoutField, PaymentMethodFieldCapability>
>

export interface CountryItem {
  code: string
  name: string
}

export interface CountrySubdivisionItem {
  country_code: string
  code: string
  iso_code: string
  name: string
}

export interface GeoInfoResponse {
  ip: string
  code: string | null
  name: string | null
  regionCode: string | null
  city: string | null
  timezone: string | null
  lat: number | null
  lon: number | null
}

export interface CurrencyItem {
  code: string
  symbol: string
  decimals: number
  rate: number
  countries: string[]
}
